import React from 'react';

const DesktopIcon = ({color = '#2C2C2C'}) => {
  return (
    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.125 1.3125H1.875C1.62891 1.3125 1.4375 1.53125 1.4375 1.75V7H14.5625V1.75C14.5625 1.53125 14.3438 1.3125 14.125 1.3125ZM15.875 7V8.3125V9.625C15.875 10.6094 15.082 11.375 14.125 11.375H10.0781L10.2969 12.6875H11.7188C12.0742 12.6875 12.375 12.9883 12.375 13.3438C12.375 13.7266 12.0742 14 11.7188 14H9.75H6.25H4.28125C3.89844 14 3.625 13.7266 3.625 13.3438C3.625 12.9883 3.89844 12.6875 4.28125 12.6875H5.67578L5.89453 11.375H1.875C0.890625 11.375 0.125 10.6094 0.125 9.625V8.3125V7V1.75C0.125 0.792969 0.890625 0 1.875 0H14.125C15.082 0 15.875 0.792969 15.875 1.75V7ZM1.4375 8.3125V9.625C1.4375 9.87109 1.62891 10.0625 1.875 10.0625H6.66016H6.6875H9.28516H9.3125H14.125C14.3438 10.0625 14.5625 9.87109 14.5625 9.625V8.3125H1.4375ZM7.01562 12.6875H8.95703L8.73828 11.375H7.23438L7.01562 12.6875Z"
        fill={color}
      />
    </svg>
  );
};

export default DesktopIcon;
